import { Box } from "@mui/material";

import CesiumMap from "./CesiumMap";
import Drawer from "./Drawer";

export default function index() {
  return (
    <Box
      sx={{
        width: "100dvw",
        height: "100dvh",
      }}
    >
      <CesiumMap />
      <Drawer />
    </Box>
  );
}
